import { integrationEventQueueSchema } from './integrationEventQueue';
import { IntegrationType } from '../integrationType';
export const integrationOrgInfoSchema = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationOrgInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        source: {
            type: 'string',
            minLength: 1
        },
        sourceID: { type: 'string' },
        createdAt: { type: 'string', format: 'date-time' },
        integrationType: { type: 'string', enum: Object.values(IntegrationType) },
        sqsQueueUrl: { type: 'string' },
        eventQueues: { type: 'array', items: { $ref: integrationEventQueueSchema.$id } }
    },
    required: ['orgID', 'source', 'sourceID']
};
//# sourceMappingURL=integrationOrgInfo.js.map